export class EcommerceExchangeDto {
  exchanges: ecommerceValue;
  link: string;
  price: number;
  promotion_price: number;
  constructor() {
    this.exchanges = { key : 0 , image: '' , value: ''};
    this.link = '';
    this.promotion_price = 0;
    this.price = 0;
  }
}

// tslint:disable-next-line:class-name
export interface ecommerceValue {
  key: number;
  value: string;
  image: string;
}

export const defaultValueEcommerce: ecommerceValue[] = [
  {
    key: 1,
    value: 'Tiki',
    image: 'data:image/png;base64,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'
  },
  {
    key: 3,
    value: 'Sendo',
    image: 'https://cdn.chanhtuoi.com/uploads/2020/02/w400/sendo.png.webp',
  },
  {
    key: 4,
    value: 'Lazada',
    image: 'https://laz-img-cdn.alicdn.com/tfs/TB1PApewFT7gK0jSZFpXXaTkpXa-200-200.png',
  },
  {
    key: 2,
    value: 'Shopee',
    image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRAjg7pc9TH1HVj0R_ficIdShUL78IBOZkUdLqAOpcI10QOEJ6zryDjyXdb-dPQpfEj5p0&usqp=CAU',
  },
  {
    key: 5,
    value: 'Website',
    image: 'https://png.pngtree.com/png-clipart/20190619/original/pngtree-vector-web-icon-png-image_3997299.jpg',
  },
  {
    key: 7,
    value: 'Tiktok shop',
    image: 'https://assets.icheck.vn/image/2025/app/12/2/c92aab7836a052023341b7b40849c1d7.png',
  }
];
export class EcommerceSaveDb {
  id: number ;
  link: string;
  price: number;
  promotion_price: number;
  defaultEcommerce: ecommerceValue;
  disabled: boolean;
  constructor() {
    this.id = 0;
    this.link = '';
    this.price = 0;
    this.promotion_price = 0;
    this.disabled = false;
    this.defaultEcommerce = {key: 0, value: '' , image : ''};
  }
}
